import type { PaymentCheckoutOutcome } from '@/shared/lib/paymentReturnHandler'

/**
 * i18n key for a contextual PSP return toast, or null when the page handles UX itself.
 */
export function resolvePaymentReturnToastKey(
  pathname: string,
  outcome: PaymentCheckoutOutcome | null,
): string | null {
  if (outcome === null) {
    return null
  }

  if (pathname === '/cart' || pathname.endsWith('/cart')) {
    return outcome === 'cancel' ? 'cart.toast.checkout_cancel' : null
  }

  if (pathname.includes('/me/reservations/')) {
    return outcome === 'cancel'
      ? 'reservation.my_reservations.payment_checkout_cancelled'
      : 'reservation.my_reservations.payment_checkout_pending'
  }

  if (pathname.includes('/reservation/confirmation/')) {
    return outcome === 'success' ? 'reservation.confirmation.payment_checkout_pending' : null
  }

  if (pathname.includes('/reservation/high-season/')) {
    return outcome === 'cancel'
      ? 'reservation.high_season.checkout.cancel_toast'
      : 'reservation.high_season.checkout.pending_toast'
  }

  if (pathname.includes('/me/tickets/')) {
    return outcome === 'cancel'
      ? 'ticketing.checkout.cancel_toast'
      : 'ticketing.checkout.pending_toast'
  }

  if (pathname.includes('/me/match-tickets')) {
    return outcome === 'cancel'
      ? 'match_event.checkout.cancel_toast'
      : 'match_event.checkout.pending_toast'
  }

  if (pathname.includes('/ticketing/offers/')) {
    return outcome === 'cancel'
      ? 'ticketing.checkout.offer_cancel_toast'
      : 'ticketing.checkout.offer_pending_toast'
  }

  if (pathname.includes('/lottery/draws/')) {
    return outcome === 'cancel'
      ? 'lottery.checkout.cancel_toast'
      : 'lottery.checkout.pending_toast'
  }

  if (pathname.includes('/group-trips/')) {
    return outcome === 'cancel'
      ? 'group-trip.checkout.cancel_toast'
      : 'group-trip.checkout.pending_toast'
  }

  if (pathname.includes('/partner-offers/')) {
    return outcome === 'cancel'
      ? 'partner-offer.checkout.cancel_toast'
      : 'partner-offer.checkout.pending_toast'
  }

  return null
}
